"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEDULING_MATRIX_COLUMN_TIME_PRESET = void 0;
const react_1 = __importDefault(require("react"));
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const View_1 = require("../View");
const TimeHeaderCell = ({ value, strong, leftValue }) => (react_1.default.createElement(StackView_1.StackView, { root: true, spaceFill: View_1.SPACE_FILL.all, align: StackView_1.STACK_ALIGN.center, direction: StackView_1.STACK_DIRECTION.row, distribution: StackView_1.STACK_DISTRIBUTION.end },
    leftValue && (react_1.default.createElement(Text_1.Text, { weight: Text_1.TEXT_WEIGHT.bold, style: { position: 'absolute', left: -4 } }, leftValue)),
    react_1.default.createElement(StackView_1.StackView, { style: { right: -8, position: 'relative', width: 16 }, align: StackView_1.STACK_ALIGN.center, direction: StackView_1.STACK_DIRECTION.row, distribution: StackView_1.STACK_DISTRIBUTION.center },
        react_1.default.createElement(Text_1.Text, { weight: strong ? Text_1.TEXT_WEIGHT.bold : Text_1.TEXT_WEIGHT.normal }, value))));
exports.SCHEDULING_MATRIX_COLUMN_TIME_PRESET = [
    {
        renderCel: () => react_1.default.createElement(TimeHeaderCell, { value: 1, leftValue: 12 })
    },
    ...[2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((value) => ({
        renderCel: () => react_1.default.createElement(TimeHeaderCell, { value: value, strong: value % 2 == 0 })
    }))
].map((i, idx) => (Object.assign(Object.assign({}, i), { key: `${idx}` })));
//# sourceMappingURL=timeHeader.js.map